import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(aad|th)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(a|b)/i,
  abbreviated: /^(ad|bc)/i,
  wide: /^(anno domini|ciise horteed)/i,
};
const parseEraPatterns = {
  any: [/^a/i, /^(b|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^Rubuca[1234]/i,
  wide: /^Rubuca [1234]aad/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/Rubuca1/i, /Rubuca2/i, /Rubuca3/i, /Rubuca4/i],
  wide: [/^Rubuca 1aad/i, /Rubuca 2aad/i, /Rubuca 3aad/i, /Rubuca 4aad/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmaosnd]/i,
  abbreviated: /^(jan|feb|mar|abr|may|jun|jul|ogo|seb|okt|nof|dis)/i,
  wide: /^(janaayo|febraayo|maarso|abriil|maayo|juun|juulay|ogosto|sebtambar|oktoobar|noofambar|diisambar)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  abbreviated: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^a/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^og/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i,
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^maar/i,
    /^a/i,
    /^maay/i,
    /^juun/i,
    /^juul/i,
    /^og/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[ais(kh)j]/i,
  short: /^(ax|is|sa|ar|kh|ji|sa)/i,
  abbreviated: /^(axd|isn|sal|arb|kha|jim|sab)/i,
  wide: /^(axad|isniin|salaasa|arbaca|khamiis|jimce|sabti)/i,
};
const parseDayPatterns = {
  narrow: [/^a/i, /^i/i, /^s/i, /^a/i, /^kh/i, /^j/i, /^s/i],
  any: [/^ax/i, /^i/i, /^sal/i, /^ar/i, /^kh/i, /^j/i, /^sab/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(subaxnimo|galabnimo|saq badhka|duhur|subax|galab|fiidka|habeen)/i,
  abbreviated:
    /^(subaxnimo|galabnimo|saq badhkii|duhur|subax|galab|fiidka|habeen)/i,
  wide: /^(subaxdii|gelinka dambe|saq badhkii|duhur|subax|galab|fiidka|habeen)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /^subaxnimo/i,
    pm: /^galabnimo/i,
    midnight: /^saq badhka/i,
    noon: /^duhur/i,
    morning: /subax/i,
    afternoon: /galab/i,
    evening: /fiidka/i,
    night: /habeen/i,
  },
  abbreviated: {
    am: /^subaxnimo/i,
    pm: /^galabnimo/i,
    midnight: /^saq badhkii/i,
    noon: /^duhur/i,
    morning: /subax/i,
    afternoon: /galab/i,
    evening: /fiidka/i,
    night: /habeen/i,
  },
  any: {
    am: /^subaxdii/i,
    pm: /^gelinka dambe/i,
    midnight: /^saq badhkii/i,
    noon: /^duhur/i,
    morning: /subax/i,
    afternoon: /galab/i,
    evening: /fiidka/i,
    night: /habeen/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

export default match;
